import { Component } from 'react';
import { reportFrontendError } from '../lib/frontend-error-reporter';

export class FrontendErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    reportFrontendError(error, {
      source: 'react-boundary',
      componentStack: info.componentStack || '',
    });
  }

  render() {
    if (this.state.failed) {
      return (
        <main
          style={{
            minHeight: '100vh',
            display: 'grid',
            placeItems: 'center',
            padding: 24,
            textAlign: 'center',
          }}
        >
          <div>
            <h1>페이지를 불러오지 못했습니다.</h1>
            <button type="button" onClick={() => window.location.reload()}>
              다시 시도
            </button>
          </div>
        </main>
      );
    }
    return this.props.children;
  }
}

export function RuntimeErrorBoundary({ children }) {
  if (typeof window === 'undefined') return children;
  return <FrontendErrorBoundary>{children}</FrontendErrorBoundary>;
}
